<template lang="pug">
  .recipe-description
    TheContent(v-for="item in parsedContent" :key="item.id" :elem="item") 
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import TheContent from '~/components/content/TheContent';
  import { prepareContent } from '~/utils/content/prepareContent';

  export default defineNuxtComponent({
    name: 'RecipeDescription',

    components: {
      TheContent,
    },

    props: {
      content: {
        type: Array as PropType<TContent[]>,
        required: true,
      },
    },

    computed: {
      parsedContent() {
        return prepareContent(this.content, false);
      },
    },
  });
</script>

<style lang="scss">
  .recipe-description {
    margin: 0px 24px;

    @include fontNormalText(true);

    @include tablet {
      @include fontMediumText;
    }

    p {
      margin-bottom: 16px;
    }

    a {
      text-decoration-color: $main;
      color: black;
    }

    img {
      max-width: 100%;
      height: auto;
    }

    iframe {
      width: 100% !important;
    }

    img.border {
      border: solid 1px #ccc;
    }

    @include print {
      @include fontTinyText;
      color: black;
    }
  }
</style>
